import axios from "axios"

const BASE_URL = "/api/bsp"

export default {
  /**
   * Initialize a BSP session and get an ephemeral token
   * @param {number} agreeability - Agreeability level of the AI (0-100)
   * @param {string} [productContext] - Optional product context for the AI
   * @returns {Promise<Object>} Response with ephemeral token
   */
  async initializeBSP (agreeability, productContext = "") {
    return axios.post(`${BASE_URL}/initialize_bsp/`, {
      agreeability,
      product_context: productContext
    })
  },

  /**
   * Save conversation transcript to backend
   * @param {string} transcript - The conversation transcript
   * @returns {Promise<Object>} Response from the server
   */
  async saveTranscript (transcript) {
    return axios.post(`${BASE_URL}/save_transcript/`, {
      transcript
    })
  }
}
